<div class="verso">
    <div class="table">
        <div class="table-cell">
            <h6 *ngIf="subtitle != ''" class="section-subtitle" style="margin-bottom: 28px;">{{subtitle}}</h6>
            <h1>{{name}}</h1>
            <ng-content></ng-content>
        </div>
    </div>
</div>
